import { isPatron } from "util";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Ad from "components/Ad/Ad";
import PleaseSupportUs from "components/PleaseSupportUs";
import useCanRunAds from "hooks/useCanRunAds";

import styles from "./Leaderboard.module.scss";

const Leaderboard = () => {
  const canRunAds = useCanRunAds();
  const profile = useSelector((state) => state.firebase.profile);
  const [randomRoll, setRandomRoll] = useState();

  useEffect(() => {
    setRandomRoll(Math.random());
  }, []);

  if (isPatron(profile)) return null;

  const ad =
    !canRunAds || randomRoll < 0.3 ? (
      <PleaseSupportUs always height={90} width={728} />
    ) : randomRoll < 0.5 ? (
      <Ad id="bcw" />
    ) : randomRoll < 0.7 ? (
      <Ad id="commandzone" />
    ) : randomRoll < 0.8 ? (
      <Ad id="heavyPlay" />
    ) : randomRoll < 0.84 ? (
      <Ad id="archidekt" />
    ) : randomRoll < 0.88 ? (
      <Ad id="cc" />
    ) : randomRoll < 0.92 ? (
      <Ad id="ch" />
    ) : randomRoll < 0.96 ? (
      <Ad id="csb" />
    ) : (
      <Ad id="fabrec" />
    );

  return <div className={styles.leaderboard}>{ad}</div>;
};

export default Leaderboard;
